<form [formGroup]="personaFisicaFormGroup">
  <div>
    <ng-container formGroupName="rol">
      <mat-form-field class="col-12">
        <mat-label>Tipo de rol:</mat-label>
        <mat-select formControlName="tipo_rol_id" required (selectionChange)="cambioTipoRol($event)">
          <mat-option *ngFor="let tipos_rol of formInput.tipos_rol" [value]="tipos_rol.id">
            {{tipos_rol.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="personaFisicaFormGroup.get('rol').get('tipo_rol_id')?.hasError('required')">
          Debe ingresar un tipo de rol
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="section-row">
    <div class="row" [hidden]="ocultarAcreditacion()" class="certificado">
      <ng-container formGroupName="rol" *ngIf="!acreditacionRepresentacionLink; else linkAcreditacionRepresentacion">
        <mat-form-field appearance="standard" required class="mat-form-field-acreditacion">
          <mat-label>Acreditación de representación: *</mat-label>
          <ngx-mat-file-input formControlName="acreditacion_representacion" accept=".pdf, .jpeg, .jpg, .png, .gif"
            (change)="onFileChange('acreditacion_representacion')" placeholder="Acreditación de representación">
          </ngx-mat-file-input>
          <mat-icon matSuffix>
            <fa-icon icon="paperclip"></fa-icon>
          </mat-icon>
          <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</mat-hint>
          <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #linkAcreditacionRepresentacion>
        <a href="{{acreditacionRepresentacionLink}}" target="_blank">Ver acreditacion de representacion</a>
        <ng-container *ngIf="!modificarParam">
          <rpe-ui-button icon="upload" (onClick)="uploadNewAcreditacionRepresentacion()">Subir nuevo
            archivo</rpe-ui-button>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput placeholder="Nombre completo:" formControlName="nombre_completo" required
        [readOnly]="camposLectura()">
      <mat-error *ngIf="personaFisicaFormGroup.get('nombre_completo')?.hasError('required')">
        Debe ingresar nombre completo
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <h4 class="secondary-header"> Documento</h4>
  </div>
  <rpe-documento-persona-form [formInput]="documentoPersonaFormInput">
  </rpe-documento-persona-form>

  <div class="row">
    <h4 class="secondary-header"> Domicilio oficina central</h4>
  </div>
  <div class="row">
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaFormInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)">
    </rpe-direcciones-geograficas-form>
  </div>

  <h5 class="secondary-header">Teléfonos</h5>

  <div class="row">
    <rpe-telefonos-form [formInput]="formInputTelefono" (formStatusChanges)="telefonoFormStatusChange($event)"
      (formValueChanges)="telefonoFormValueChange($event)"></rpe-telefonos-form>
  </div>

  <h5 class="secondary-header">Correos electrónicos</h5>
  <div formArrayName="email_tecnico" *ngFor="let oc of email_tecnico.controls; index as i">
    <div class="row">
      <mat-form-field class="col-11">
        <input matInput placeholder="Correo electrónico (técnico):" [formControlName]="i" required>
      </mat-form-field>
      <mat-error *ngIf="personaFisicaFormGroup.get('email_tecnico')?.get('i')?.hasError('required')">
        Debe ingresar un correo electrónico
      </mat-error>
      <mat-error *ngIf="personaFisicaFormGroup.get('email_tecnico')?.get('i')?.hasError('email')">
        Debe ingresar un correo electrónico válido
      </mat-error>
      <div class="col-1" *ngIf="email_tecnico.length > 1">
        <button type="button" class="float-right" mat-icon-button (click)="eliminarUnEmailTecnico(i)" color="warn"
          [disabled]="email_tecnico.length < 2" matTooltip="Eliminar correo electrónico (técnico)">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <button type="button" class="buttonNewMail" (click)="agregarOtroEmailTecnico()" mat-icon-button color="primary"
    matTooltip="Agregar nuevo correo electrónico (técnico)">
    <mat-icon>
      <fa-icon icon="plus"></fa-icon>
    </mat-icon>
  </button>
</form>